import Vue from "vue";
import Router from "vue-router";
//import Home from "./views/Home.vue";
import MainMenu from "@/views/MainMenu.vue";

import Kraal from "@/views/Kraal/Kraal.vue";
import KraalInfo from "@/views/Kraal/KraalInfo.vue";
import Morbidities from "@/views/Kraal/Morbidities.vue";
import MorbiditiesGraph from "@/views/Kraal/MorbiditiesGraph.vue";
import Mortalities from "@/views/Kraal/Mortalities.vue";
import MortalitiesGraph from "@/views/Kraal/MortalitiesGraph.vue";
import Feeding from "@/views/Kraal/Feeding.vue";
import FeedingGraph from "@/views/Kraal/FeedingGraph.vue";
import AnimalsInKraal from "@/views/Kraal/AnimalsInKraal.vue";

import AnimalScanSearch from "@/views/AnimalScanSearch.vue";

import Animal from "@/views/Animal/Animal.vue";
import AnimalInfo from "@/views/Animal/AnimalInfo.vue";
import Growth from "@/views/Animal/Growth.vue";
import Health from "@/views/Animal/Health.vue";
import Processing from "@/views/Animal/Processing.vue";

import Hospital from "@/views/Hospital/Hospital.vue";
import DetailsInput from "@/views/Hospital/DetailsInput.vue";

import Count from "@/views/Count/Count.vue";
import CountMenu from "@/views/Count/CountMenu.vue";
import Scan from "@/views/Count/Scan.vue";

import SyncData from "@/views/SyncData.vue";

import Outbox from "@/views/Outbox.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      alias: ["/index.html", "/index"],
      name: "main-menu",
      component: MainMenu
    },
    {
      path: "/kraal",
      name: "kraal",
      component: Kraal,
      children: [
        {
          path: "kraal-info",
          component: KraalInfo
        },
        {
          path: "morbidities",
          component: Morbidities
        },
        {
          path: "morbidities-graph",
          component: MorbiditiesGraph
        },
        {
          path: "mortalities",
          component: Mortalities
        },
        {
          path: "mortalities-graph",
          component: MortalitiesGraph
        },
        {
          path: "feeding",
          component: Feeding
        },
        {
          path: "feeding-graph",
          component: FeedingGraph
        },
        {
          path: "animals-in-kraal",
          component: AnimalsInKraal
        }
      ]
    },
    {
      path: "/animal",
      name: "animal",
      component: Animal,
      children: [
        {
          path: "animal-scan-search",
          component: AnimalScanSearch,
          props: {
            onAnimalSelected: () => console.log("Animal onAnimalSelected()")
          }
        },
        {
          path: "animal-info",
          component: AnimalInfo
        },
        {
          path: "processing",
          component: Processing
        },
        {
          path: "growth",
          component: Growth
        },
        {
          path: "health",
          component: Health
        }
      ]
    },
    {
      path: "/hospital",
      name: "hospital",
      component: Hospital,
      children: [
        {
          path: "animal-scan-search",
          component: AnimalScanSearch,
          props: {
            onAnimalSelected: () => console.log("Hospital onAnimalSelected()")
          }
        },
        {
          path: "details-input",
          component: DetailsInput
        }
      ]
    },
    {
      path: "/count",
      name: "count",
      component: Count,
      children: [
        // {
        //   path: "count-menu",
        //   component: CountMenu
        // },
        {
          path: "scan",
          component: Scan
        }
      ]
    },
    {
      path: "/sync-data",
      name: "sync-data",
      component: SyncData
    },
    {
      path: "/outbox",
      name: "outbox",
      component: Outbox
    }
  ]
});
